/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUser: {
  name: 'user';
  data: string;
} = {
  name: 'user',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM7 20a5 5 0 0 1 10 0 1 1 0 1 0 2 0 7 7 0 1 0-14 0 1 1 0 1 0 2 0Z" fill="currentColor"/></svg>`,
};
